import { Flex, Stack, Text, Textarea } from "@chakra-ui/react";
import { AiFillFolder, AiOutlineSend } from "react-icons/ai";

function MeetingMessagingTextBox() {
  return (
    <Flex flexDirection={"row"} alignItems="center" gap="10px">
      <AiFillFolder fontSize={"2em"} color="#7D96B3" />

      <Text fontSize="2em"> 😍</Text>
      <Stack
        direction="row"
        alignItems={"center"}
        borderRadius={"10px"}
        p="0px 5px"
        bg="#D9D9D94F"
      >
        <Textarea
          className="scroll-container"
          rows="1"
          size={"sm"}
          style={{ resize: "none" }}
          // color="#fff"
          fontWeight="600"
          fontSize={[".8em", "unset"]}
          _placeholder={{ color: "#7D96B3", fontWeight: "initial" }}
          placeholder="Type a message here"
          type="text"
          bg={"transparent"}
          overflow=""
          border="none"
        />
        <Stack direction={"row"} alignItems="center" ml="-80px" mt="20px">
          <Flex
            bg="#50BB69"
            color="#fff"
            borderRadius={"5px"}
            w="20px"
            h="20px"
            justifyContent="center"
            alignItems="center"
          >
            <AiOutlineSend fontSize={"1.2em"} cursor="pointer" />
          </Flex>
        </Stack>
      </Stack>
    </Flex>
  );
}

export default MeetingMessagingTextBox;
